export enum NodeType {
  MustacheStatement = 'MustacheStatement',
  BlockStatement = 'BlockStatement',
  PartialStatement = 'PartialStatement',
  PartialBlockStatement = 'PartialBlockStatement',
  ContentStatement = 'ContentStatement',
  CommentStatement = 'CommentStatement',
  SubExpression = 'SubExpression',
  PathExpression = 'PathExpression',
  StringLiteral = 'StringLiteral',
  BooleanLiteral = 'BooleanLiteral',
  NumberLiteral = 'NumberLiteral',
  UndefinedLiteral = 'UndefinedLiteral',
  NullLiteral = 'NullLiteral',
  Hash = 'Hash',
  HashPair = 'HashPair',
  Program = 'Program',
}

export type LiteralType =
  | NodeType.StringLiteral
  | NodeType.BooleanLiteral
  | NodeType.NumberLiteral
  | NodeType.UndefinedLiteral
  | NodeType.NullLiteral;
